import { forwardRef, type Ref, type SVGProps } from "react";

export function BadgeIcon(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        d="M11.4993 6.49935H8.49935M10.1793 8.49935H8.49935M12.166 12.8327H3.83268C2.72811 12.8327 1.83268 11.9373 1.83268 10.8327V5.16602C1.83268 4.06145 2.72811 3.16602 3.83268 3.16602H12.166C13.2706 3.16602 14.166 4.06145 14.166 5.16602V10.8327C14.166 11.9373 13.2706 12.8327 12.166 12.8327ZM5.33268 8.83268C5.79292 8.83268 6.16602 8.45959 6.16602 7.99935V7.33268C6.16602 6.87245 5.79292 6.49935 5.33268 6.49935C4.87245 6.49935 4.49935 6.87245 4.49935 7.33268V7.99935C4.49935 8.45959 4.87245 8.83268 5.33268 8.83268Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const ForwardRef = forwardRef(BadgeIcon);
export default ForwardRef;
